import React from "react";
import * as authSelectors from "../auth/authSelectors";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { routePatterns } from "../../appRoutingHelpers";
import { ErrorBoundaryComponent } from "../../components/ErrorBoundaryComponent";

export const AppUnprotectedRoutes = () => {
  const isAuthenticated = useSelector(authSelectors.isUserAuthenticated);
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate(routePatterns.login);
      return;
    }
    navigate(routePatterns.selectOrganization);
  }, [isAuthenticated, navigate]);

  return (
    <ErrorBoundaryComponent>
      {!isAuthenticated || !organizationKeyName ? (
        <Outlet />
      ) : (
        <Navigate to={`/organizations/${organizationKeyName}`} />
      )}
    </ErrorBoundaryComponent>
  );
};
